<template>
    <div class="flex justify-center pt-8">
        <span
            class="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-white px-4 py-2 text-xs font-medium text-black shadow-sm"
        >
            <img
                src="https://tucatalogo.co/img/icons/android-chrome-384x384.png"
                alt="tucatalogo.co"
                class="h-3.5 w-3.5 rounded-full"
            />
            Crea tu catálogo gratis — tucatalogo.co
        </span>
    </div>
</template>

<script>
// Copia visual del FooterCta del catálogo público (repos/catalog).
export default {
    name: "CatalogWatermark"
};
</script>
